import React, { useMemo, useState } from 'react'
import {
  Box, Loader, Text,
} from '@usap/uicomponents'
import RMAReturnItemInfo from './RMAReturnItemInfo'
import RMAReturnOrderInfo from './RMAReturnOrderInfo'
import RMAReturnStep from './RMAReturnStep'
import Lightbox from '../../../common/Lightbox'
import ErrorMessageLb from '../ErrorMessageLb'
import {
  BUTTON_TEXT_LABEL,
  BUTTON_TEXT_LABEL_WMO,
  eligibleStatuses,
} from './constant'
import RMAReturnButtonsWMO from './RMAReturnButtonsWMO'
import { VerticalLine } from './style/RMAReturnDetailsWMO.css'
import CancelReturnWMO from '../CancelReturnWMO'
import { checkReturnEligibility } from '@usap/carparts/src/shared/helpers'

const RMAReturnDetailsWMO = props => {
  const {
    isDesktop,
    isBot,
    Link,
    data,
    onCancelReturn,
    loading,
    handleReason,
    appSteps,
    setAppSteps,
    imgSteps,
    setImgSteps,
    docSteps,
    setDocSteps,
    customerOrder,
    fileUpload,
    setFileUpload,
    formFile,
    setFormFile,
    tempStep,
    setTempStep,
    reqElem,
    setReqElem,
    setReturnQuantity,
    setDisplayReturnDetails,
    showTabs,
    setReturnDetailsData,
    mechanicDiagnosis,
    creditStatus,
    returnRequestStatus,
    OpenChatHandler,
    resetReturn,
    displayCancelConfirmation,
    submitForm,
    showErrorMessage,
    showReason,
    partSelection,
    setPartsSelection,
    isPartEligible,
    isMultiplePart,
    errorSteps,
    setErrorSteps,
    buttonText,
    setButtonText,
    displayErrorMessage,
    setDisplayErrorMessage,
    displayCancel,
    setDisplayCancel,
    submitSelect,
    selectedPartStatus,
    selectedPartETA,
    selectedPartIndx,
    setSelectedPartIndx,
    selectedPart,
    setSelectedPart,
    setItemImage,
    orderItems,
    partReturnEligibilityList,
    setPartReturnEligibilityList,
  } = props

  const {
    merchant_order_id: merchantOrderId,
    order_id: orderId,
    customers_email_address: emailAddress,
    order_status: orderStatus,
    order_date: orderDate,
    parts,
    return_request: returns,
  } = data

  const multipleItemsPresent = partSelection.length > 1;

  const selectedPartInfo = useMemo(() => {
    if (!Array.isArray(partSelection)) return {};
    if (partSelection.length === 1) return partSelection[0];
    if (partSelection.length > 1) {
      return partSelection.find((product) => product.sku === selectedPart) || {};
    }
    return {};
  }, [selectedPart, partSelection]);

  const { eligible: selectedItemEligibleForReturn } = checkReturnEligibility(selectedPartInfo);

  return (
    <>
      <Lightbox key="errorLightbox" isDisplay={displayErrorMessage}>
        <ErrorMessageLb />
      </Lightbox>

      <Lightbox key="cancelLightbox" isDisplay={displayCancel}>
        <CancelReturnWMO
          onCancelReturn={resetReturn}
          setDisplayCancel={setDisplayCancel}
        />
      </Lightbox>

      <Box
        key="returnDetailsMainBox"
        width="100%"
        pad="0px"
        style={{
          flexDirection: isDesktop && showTabs && selectedItemEligibleForReturn ? 'row' : 'column',
          gap: isDesktop ? '32px' : '16px',
        }}
      >
        <Box
          direction="column"
          id="rma-page-2nd-column"
          style={{ 
            maxWidth: showTabs && selectedItemEligibleForReturn && isDesktop ? '592px' : '100%',
          }}
          width="100%"
          pad="0px"
        >
          <RMAReturnOrderInfo
            key="returnRMAOrderInfo"
            isMultiplePart={isMultiplePart}
            isDesktop={isDesktop}
            isBot={isBot}
            merchantOrderId={merchantOrderId}
            orderDate={orderDate}
            orderStatus={orderStatus}
            errorSteps={errorSteps}
            isPartEligible={isPartEligible}
            setItemImage={setItemImage}
            showTabs={showTabs}
            selectedPartIndx={selectedPartIndx}
            selectedPart={selectedPart}
            showReason={showReason}
            multipleItemsPresent={multipleItemsPresent}
        />
          <Box justify="start" direction="column">
            {isMultiplePart
            && partSelection.map((part, ikey) => (
              <>
                <RMAReturnItemInfo
                  key="multiRMAReturnItemInfo"
                  ikey={ikey}
                  buttonLabel={buttonText}
                  isMultiplePart={isMultiplePart}
                  submitSelect={submitSelect}
                  isDesktop={isDesktop}
                  isBot={isBot}
                  Link={Link}
                  selectedPart={selectedPart}
                  eligibleStatuses={eligibleStatuses}
                  setReturnQuantity={setReturnQuantity}
                  setDisplayReturnDetails={setDisplayReturnDetails}
                  setReturnDetailsData={setReturnDetailsData}
                  parts={part}
                  creditStatus={creditStatus}
                  returnRequestStatus={returnRequestStatus}
                  orderInfo={{
                    merchantOrderId, emailAddress, orderId,
                  }}
                  returns={returns || []}
                  setItemImage={setItemImage}
                  setSelectedPart={setSelectedPart}
                  selectedPartIndx={selectedPartIndx}
                  setSelectedPartIndx={setSelectedPartIndx}
                  showTabs={showTabs}
                  isPartEligible={isPartEligible}
                  setErrorSteps={setErrorSteps}
                  setPartsSelection={setPartsSelection}
                  OpenChatHandler={OpenChatHandler}
                  multipleItemsPresent={multipleItemsPresent}
                  partReturnEligibilityList={partReturnEligibilityList}
                  setPartReturnEligibilityList={setPartReturnEligibilityList}
                />
              </>
            ))}

            {/* TBD: Perform checks and remove the below code block as 'isMultiplePart' results to true even for a single item order. */}
            {!isMultiplePart && (
            <>
              <RMAReturnItemInfo
                key="singleRMAReturnItemInfo"
                buttonLabel={buttonText}
                isMultiplePart={isMultiplePart}
                isDesktop={isDesktop}
                showTabs={showTabs}
                isBot={isBot}
                selectedPart={selectedPart}
                eligibleStatuses={eligibleStatuses}
                setReturnQuantity={setReturnQuantity}
                setReturnDetailsData={setReturnDetailsData}
                setDisplayReturnDetails={setDisplayReturnDetails}
                parts={parts}
                returns={returns || []}
                setItemImage={setItemImage}
                setSelectedPart={setSelectedPart}
                selectedPartIndx={selectedPartIndx}
                setSelectedPartIndx={setSelectedPartIndx}
                creditStatus={creditStatus}
                returnRequestStatus={returnRequestStatus}
                orderInfo={{
                  merchantOrderId, emailAddress, orderId,
                }}
                isPartEligible={isPartEligible}
                setErrorSteps={setErrorSteps}
                setPartsSelection={setPartsSelection}
                OpenChatHandler={OpenChatHandler}  
              />
            </>
            )}
          </Box>
        </Box>

        {selectedItemEligibleForReturn && isDesktop && <VerticalLine />}

        <Box id="rma-page-1st-column" width="100%" direction="column">
          {
            selectedItemEligibleForReturn && <>
              {((!isMultiplePart && isPartEligible) || (submitSelect && showReason)) && (
              <>
                {loading && <Loader />}
                <Box>
                  <RMAReturnStep
                    key="returnRMAStep"
                    isDesktop={isDesktop}
                    selectedPart={selectedPart}
                    handleReason={handleReason}
                    appSteps={appSteps}
                    merchantOrderId={merchantOrderId}
                    setAppSteps={setAppSteps}
                    partSelection={partSelection}
                    imgSteps={imgSteps}
                    setImgSteps={setImgSteps}
                    activeCount={selectedPartIndx}
                    docSteps={docSteps}
                    setDocSteps={setDocSteps}
                    fileUpload={fileUpload}
                    setFileUpload={setFileUpload}
                    customerOrder={customerOrder}
                    formFile={formFile}
                    setFormFile={setFormFile}
                    tempStep={tempStep}
                    setTempStep={setTempStep}
                    reqElem={reqElem}
                    setReqElem={setReqElem}
                    errorSteps={errorSteps}
                    setErrorSteps={setErrorSteps}
                    showErrorMessage={showErrorMessage}
                    displayErrorMessage={displayErrorMessage}
                    setDisplayErrorMessage={setDisplayErrorMessage}
                    selectedPartETA={selectedPartETA}
                    setReturnQuantity={setReturnQuantity}
                    orderStatus={selectedPartStatus}
                    mechanicDiagnosis={mechanicDiagnosis}
                    isBot={isBot}
                    eligibleStatuses={eligibleStatuses}
                    OpenChatHandler={OpenChatHandler}
                    submitSelect={submitSelect}
                    buttonLabel={buttonText}
                  />
                </Box>
              </>
              )}
            </>
          }
          <RMAReturnButtonsWMO
            key="returnBtnComp"
            isPartEligible={isPartEligible}
            setButtonText={setButtonText}
            idName="submitReturnItem"
            displayCancelConfirmation={displayCancelConfirmation}
            submitForm={submitForm}
            buttonLabel={buttonText}
            itemList={parts}
            partReturnEligibilityList={partReturnEligibilityList}
          />
        </Box>
      </Box>
    </>
  )
}

export default RMAReturnDetailsWMO
